"use client";

export default function Terms() {
    return (
        <div className="p-6 min-h-screen">
            <h1 className="text-3xl font-bold mb-6">Términos y Condiciones de Compra</h1>
            <p className="mb-4">
                Gracias por tu interés en nuestra tienda. Por favor, asegúrate de
                revisar nuestros términos y condiciones de compra antes de realizar tu
                pedido:
            </p>
            <ol className="list-decimal pl-6 space-y-4">
                <li>
                    <strong>Proceso de Compra:</strong> Al realizar una compra en nuestra
                    tienda, estás contribuyendo directamente al proyecto de “Mi Sobrino
                    Manuel”. Todos los beneficios obtenidos se destinan a apoyar su
                    importante labor.
                </li>
                <li>
                    <strong>Métodos de Pago:</strong> Aceptamos pagos a través de tarjetas
                    de crédito, débito y otros métodos de pago electrónico seguros. Los
                    detalles de pago son tratados de forma confidencial y segura.
                </li>
                <li>
                    <strong>Envíos:</strong> El tiempo de envío y los costos asociados
                    serán proporcionados durante el proceso de compra. Te garantizamos
                    que tu compra ayudará al proyecto de “Mi Sobrino Manuel”.
                </li>
                <li>
                    <strong>Devoluciones y Reembolsos:</strong> Aceptamos devoluciones
                    dentro de un plazo determinado desde la fecha de recepción del
                    producto, siempre y cuando el producto esté en su estado original y
                    no haya sido utilizado. Para obtener más información sobre el proceso
                    de devolución y reembolso, contáctanos.
                </li>
                <li>
                    <strong>Contacto:</strong> Si tienes alguna pregunta o inquietud sobre
                    tu compra, no dudes en contactarnos a través de nuestros canales de
                    atención al cliente. Estamos aquí para ayudarte.
                </li>
            </ol>
            <p className="mt-6">
                Gracias por tu apoyo a través de tu compra en nuestra tienda. Juntos
                hacemos posible un impacto positivo en el proyecto de “Mi Sobrino
                Manuel”.
            </p>
        </div>
    );
}
